import React from 'react';

import './ExecJob.scss';
import { EXECUTE_BUTTON_TEXT } from '../../../../shared/const/Tittles/Buttons';
import Button from '../../../../components/UI/Button/Button';

const ExecJob = props => {
  return (
		<div className="stage-content">
			<div className="stage-zero-btns-area">
				<Button
					className="project-button-short"
					onClick={() => {
						
					}}
				>
					<i className="icon-execute-a"></i>
					{EXECUTE_BUTTON_TEXT}
				</Button>
			</div>
		</div>
	);
};

export default ExecJob;
